@if (form) {
  <div class="container pt-3">
    <rbb-side-menu-headline headline="{{form.name}}" icon="fas fa-file-alt"/>

    @if (form.approvalDataProtectionOfficer === 'PENDING') {
      <div class="my-4 no-print">
        Das Formular als Datenschutzbeauftragte freigeben.
        <button style="min-width: 130px" class="btn btn-sm btn-success ms-3 fw-bold" (click)="openModalApprove(false)"><i class="fas fa-check" aria-hidden="true"></i>&ensp;Genehmigen</button>
        <button style="min-width: 130px" class="btn btn-sm btn-danger ms-3 fw-bold" (click)="openModalApprove(true)"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Ablehnen</button>
      </div>
    }
    <div class="my-4 fw-bold">
      Verantwortliche/-r: {{form.createdByFirstName}} {{form.createdByLastName}}
      <button class="btn btn-sm btn-primary float-end" (click)="print()">
        Drucken / PDF
      </button>
    </div>

    <app-form [form]="form" [isPreview]="true"/>
    <div class="card">
      <div class="card-body">
        <app-privacy-policy [form]="form"/>
      </div>
    </div>
  </div>
}

<ng-template #ngModalApprove>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      {{ decline ? 'Formular ablehnen' : 'Formular genehmigen'}}
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <p>Wollen Sie das Formular wirklich {{ decline ? 'ablehnen' :'genehmigen' }}?</p>
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    @if (decline) {
      <button (click)="declineForm()" class="btn btn-danger btn-sm" type="button"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Ablehnen</button>
    } @else {
      <button (click)="acceptForm()" class="btn btn-success btn-sm" type="button"><i class="fas fa-check" aria-hidden="true"></i>&ensp;Genehmigen</button>
    }
    <button (click)="closeModalApprove()" class="btn btn-secondary btn-sm" type="button">Schließen</button>
  </div>
</ng-template>
